import { delay } from "@common/utils/Time";
import mapboxgl from "mapbox-gl";
export default class MapboxContext {
    isAnimationLoopActive;
    map;
    isMapReady;
    onClickRegistry;
    constructor(containerId, mapboxToken) {
        this.isAnimationLoopActive = false;
        mapboxgl.accessToken = mapboxToken;
        this.map = new mapboxgl.Map({
            container: containerId,
            style: "mapbox://styles/avonfitzgerald/cl2l11adv001d15nyp20wpzej",
            center: [0, 25],
            zoom: 2
        });
        const navControl = new mapboxgl.NavigationControl({ showCompass: false });
        this.map.addControl(navControl, "bottom-right");
        this.map.dragRotate.disable();
        this.map.touchZoomRotate.disableRotation();
        this.onClickRegistry = {};
        this.isMapReady = false;
    }
    async holdUntilReady() {
        return new Promise((resolve) => {
            if (this.map.isStyleLoaded() || this.isMapReady) {
                this.isMapReady = true;
                resolve(true);
            }
            else {
                this.map.once("load", () => {
                    this.isMapReady = true;
                    resolve(true);
                });
            }
        });
    }
    targetCamera(lat, lng) {
        this.map.flyTo({
            center: [lng, lat],
            zoom: 6
        });
    }
    hasImage(id) {
        return this.map.hasImage(id);
    }
    loadImageBitmap(src) {
        return new Promise((resolve, reject) => {
            this.map.loadImage(src, (error, image) => {
                if (error != undefined) {
                    reject(error);
                }
                else {
                    resolve(image);
                }
            });
        });
    }
    addImageBitmap(id, image) {
        this.map.addImage(id, image);
    }
    addSourceLayer(sourceLayer) {
        this.map.addSource(sourceLayer.getId(), sourceLayer.getSource());
        this.map.addLayer(sourceLayer.getLayer());
        const onClick = (ev) => {
            const onClick = sourceLayer.getOnClick();
            onClick(ev.features[0].properties.id);
        };
        this.onClickRegistry[sourceLayer.getId()] = onClick;
        this.map.on("click", sourceLayer.getId(), onClick);
    }
    removeSourceLayer(sourceLayer) {
        this.map.removeLayer(sourceLayer.getId());
        this.map.removeSource(sourceLayer.getId());
        const onClick = this.onClickRegistry[sourceLayer.getId()];
        if (onClick != undefined) {
            this.map.off("click", sourceLayer.getId(), onClick);
        }
    }
    getSource(id) {
        return this.map.getSource(id);
    }
    getMap() {
        return this.map;
    }
    startAnimationLoop(update) {
        this.isAnimationLoopActive = true;
        const frame = async () => {
            await delay(32);
            if (!this.isAnimationLoopActive) {
                return;
            }
            update();
            window.requestAnimationFrame(frame);
        };
        frame();
    }
    stopAnimationLoop() {
        this.isAnimationLoopActive = false;
    }
    destroy() {
        this.stopAnimationLoop();
        this.map.remove();
    }
}
